<style scoped>

</style>

<template>
    <div>
        <h1>竞猜活动</h1>
        <div>
          <div v-for="(item,index) in catGuessList" :key="index" class="list-item">
            <!-- <div>
              <image :src=""/>
            </div> -->
            <div class="text">{{item.catName}}</div>

            <el-button v-if="item.pause==1" style="margin-left:10px" type="danger" @click="confirmPause(item.catGuessId, 2)">点击暂离</el-button>
            <el-button v-if="item.pause==2" style="margin-left:10px" type="primary" @click="confirmPause(item.catGuessId, 1)">取消暂离</el-button>

            <div class="text" v-if="item.pause==2">暂离</div>
            <div class="text" style="width:200px" v-if="item.pause==1">正常，活动进行中</div>
          </div>
        </div>
    </div>
</template>

<script>
import app from '@/App.vue';
import { getCatGuessList, updateGuessPauseStatus } from '@/request/api';
export default {
    name: 'ActivityList',
    data() {
      return {
        catGuessList: []
      };
    },
    methods: {
      confirmPause(catGuessId, pause) {
        var msg = '此操作将使猫咪恢复活动, 是否继续?';
        if (pause == 2) {
          msg = '此操作将使猫咪暂离, 是否继续?';
        }
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.updateGuessPauseStatus(catGuessId, pause);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
      },
      updateGuessPauseStatus(catGuessId, pause) {
        updateGuessPauseStatus({
          catGuessId: catGuessId,
          pause: pause
        }).then(res => {
            var status = res.status;
            var msg = res.msg;
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.$message.success("更新成功");
                this.getCatGuessList();
            }
        })
      },
      getCatGuessList() {
        getCatGuessList().then(res => {
            var status = res.status;
            var msg = res.msg;
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.$message.success("查询成功");
                var data = res.data;
                this.catGuessList = data;
            }
        })
      }
    },
    created(){
        this.getCatGuessList();
    }
}
</script>


<style scoped>
.list-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 10px;
}
.text {
  font-size: 20px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/guess/catGuessList.vue